import { useQuery } from '@tanstack/react-query'

import type { Pet } from 'types'
import api from 'lib/api'

const KEY = 'pets'

export function usePetByIntellitag(tagNumber?: string) {
  return useQuery(
    [KEY, tagNumber],
    () =>
      api
        .get<{ data: Pet }>(`/api/v2/pets/intellitag/${tagNumber}`)
        .then(({ data }) => data.data),
    {
      enabled: !!tagNumber,
    },
  )
}
